import React, { useEffect, useState } from 'react'
import { OverallScore } from '../types'

interface ScoreDisplayProps {
  score: OverallScore
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ score }) => {
  const [animatedScore, setAnimatedScore] = useState(0)
  const maxScore = 70 // Set maximum score to 70
  const percentage = Math.min((score.score / score.maxScore) * 100, maxScore)
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedScore(percentage)
    }, 100)
    return () => clearTimeout(timer)
  }, [percentage])

  const getColor = (score: number) => {
    if (score >= 60) return 'text-mover-purple'
    if (score >= 40) return 'text-mover-magenta'
    return 'text-mover-red'
  }

  const color = getColor(percentage)
  const label = "Needs Improvement"

  const circleCircumference = 2 * Math.PI * 60
  const strokeDashoffset = circleCircumference - (animatedScore / 100) * circleCircumference

  return (
    <div className="flex items-center justify-center mb-8">
      <div className="relative w-32 h-32">
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 128 128">
          <circle
            cx="64"
            cy="64"
            r="60"
            fill="none"
            stroke="#30314b"
            strokeWidth="8"
          />
          <circle
            cx="64"
            cy="64"
            r="60"
            fill="none"
            stroke="url(#scoreGradient)"
            strokeWidth="8"
            strokeDasharray={circleCircumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 1s ease-in-out' }}
          />
          <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#6e45e9" />
            <stop offset="100%" stopColor="#00d2e1" />
          </linearGradient>
        </svg>
        <div className="absolute inset-0 flex items-center justify-center flex-col">
          <span className={`text-3xl font-bold ${color}`}>{Math.round(animatedScore)}</span>
          <span className="text-mover-light text-xs">out of 100</span>
        </div>
      </div>
      <div className="ml-6">
        <h3 className={`text-2xl font-bold ${color}`}>{label}</h3>
        <p className="text-mover-lightest mt-2 max-w-md text-sm">
          Your website's SEO score indicates there's room for improvement. 
          Consider addressing the areas highlighted in the audit to enhance your site's performance.
        </p>
      </div>
    </div>
  )
}

export default ScoreDisplay